
import Vue from 'vue';

export default Vue.extend<any, any, any, any>({
  data() {
    return {
      isReady: false
    };
  },
  mounted() {
    if (typeof this.$el !== 'undefined' && typeof document !== 'undefined') {
      document.body.appendChild(this.$el);
      this.isReady = true;
    }
  },
  beforeDestroy() {
    // childNodes can be undefined
    if (document.body && document.body.childNodes) {
      const { childNodes } = document.body;
      // childNodes can be null
      if (childNodes && childNodes.length > 0) {
        for (let i = 0; i < childNodes.length; i++) {
          if (childNodes[i] === this.$el) {
            document.body.removeChild(this.$el);
          }
        }
      }
    }
  },
  render(h: Vue.CreateElement) {
    if (typeof this.$scopedSlots.default === 'undefined') {
      return null;
    }
    // @ts-ignore
    return this.$scopedSlots.default({ isReady: this.isReady });
  }
});
